import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { Breadcrumb } from "../../../components/Common";

import AuditFilters from "./components/AuditFilters";
import AuditList from "./components/AuditList";
import AuditDetailsModal from "./components/AuditDetailsModal";
import useAuditLogs from "./hooks/useAuditLogs";

const AuditLogsPage = () => {
    document.title = "Auditoria | NeoApp - Sistema de Gestão";

    // O hook gerencia tudo relacionado a banco e estado da listagem
    const {
        logs,
        loading,
        hasMore,
        filters,
        updateFilter,
        clearFilters,
        loadMore
    } = useAuditLogs();

    // Modal state
    const [selectedLog, setSelectedLog] = useState(null);

    const handleFilterSubmit = (newFilters) => {
        // Aplica todos de uma vez
        Object.keys(newFilters).forEach(key => updateFilter(key, newFilters[key]));
    };

    const handleClearFilters = () => {
        clearFilters();
    };

    const handleViewDetails = (log) => {
        setSelectedLog(log);
    };

    const toggleModal = () => setSelectedLog(null);

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Logs de Auditoria" />
            </div>

            <div className="border-top mb-3"></div>

            <div className="audit-container mt-3">
                <Container fluid className="px-0">
                    <Row>
                    <Col lg="12">
                        {/* Componente de Filtros (Card Horizontal ou Row) */}
                        <AuditFilters 
                            filters={filters}
                            onFilterSubmit={handleFilterSubmit}
                            onClearFilters={handleClearFilters}
                        />
                    </Col>
                    
                    <Col lg="12">
                        {/* Tabela Paginada */}
                        <AuditList
                            logs={logs}
                            loading={loading}
                            hasMore={hasMore}
                            onLoadMore={loadMore}
                            onViewDetails={handleViewDetails}
                        />
                    </Col>
                </Row>
            </Container>
            </div>

            {/* Modal de Detalhes - renderiza os diffs do objeto de auditoria */}
            {selectedLog && (
                <AuditDetailsModal 
                    isOpen={!!selectedLog}
                    toggle={toggleModal}
                    log={selectedLog}
                />
            )}
        </React.Fragment>
    );
};

export default AuditLogsPage;
